import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import styled from "styled-components";

import Triangle from "../../assets/icons/triangle.svg";
import HomeIcon from "../../assets/icons/home.png";

const TitleSection = styled.section`
  background-image: url(${(props) => props.$backgroundImage});
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  margin-top: -80px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
`;

const TitleSectionInner = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 20px;
  background: linear-gradient(180deg, rgba(0, 0, 0, 0.55) 0%, rgba(0, 0, 0, 0.25) 100%);
  color: #fff;
  width: 100%;
  height: 300px;
`;

const TitleH2 = styled.h2`
  font-size: 36px;
  font-weight: 800;
  letter-spacing: 0.02em;
  padding-top: 20px;
`;

const Breadcrumb = styled.div`
  display: flex;
  align-items: center;
  gap: 18px;
  font-size: 13px;
`;

const HomeIconImg = styled.img`
  cursor: pointer;
  width: 16px;
`;

// Start of Selection
const ArrowIconWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  line-height: 22px;
  img {
    width: 8px;
  }
`;

const SubMenuBarContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 46px;
  padding: 0 16px;
  background-color: var(--primary-c);
  font-size: 14px;
  font-weight: 700;
  box-sizing: border-box;
`;

const SubMenuBarInner = styled.ul`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
`;

const SubMenuBarItem = styled.li`
  box-sizing: content-box;
  width: ${({ $menuListWidth }) => `${$menuListWidth}%`};
  min-width: 74px;
  height: 100%;
  transition: all 0.2s ease;
  color: #fff;
  word-break: keep-all;
  text-align: center;
`;

const SubMenuBarItemSpan = styled.span`
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all 0.2s ease;
  border-radius: 10px 10px 0 0;
  padding: 0 2px;


  &.active {
    color: #186FB2;
    background-color: #fff;
    height: 54px;
    margin-top: -5px;
  }
`;


export default function MobileSubVisual({ title, activeMenu, backgroundImage, menuList, setActiveMenu }) {
  const [menuListWidth, setMenuListWidth] = useState(0);
  const navigate = useNavigate();

  const handleMenuClick = (menu) => {
    if (!setActiveMenu) return;
    setActiveMenu(menu);
  }

  useEffect(() => {
    if (!menuList?.length) return;
    const calcMenuListWidth = 100 / menuList.length;
    setMenuListWidth(Math.min(calcMenuListWidth, 50));
  }, [menuList]);

  return (
    <TitleSection $backgroundImage={backgroundImage}>
      <TitleSectionInner>
        <TitleH2>{title}</TitleH2>
        <Breadcrumb >
          <HomeIconImg
            src={HomeIcon}
            alt="홈 아이콘"
            onClick={() => navigate("/")}
          />
          <ArrowIconWrapper>
            <img src={Triangle} alt="화살표 아이콘" />
          </ArrowIconWrapper>
          {title}
          <ArrowIconWrapper>
            <img src={Triangle} alt="화살표 아이콘" />
          </ArrowIconWrapper>
          {activeMenu}
        </Breadcrumb>
      </TitleSectionInner>
      <SubMenuBarContainer>
        <SubMenuBarInner>
          {menuList.map((menu, index) => (
            <SubMenuBarItem key={index} $menuListWidth={menuListWidth}>
              <SubMenuBarItemSpan className={activeMenu === menu ? "active" : ""} onClick={() => handleMenuClick(menu)}>{menu}</SubMenuBarItemSpan>
            </SubMenuBarItem>
          ))}
        </SubMenuBarInner>
      </SubMenuBarContainer>
    </TitleSection>
  )
}
